export function appendGooglePlaceContext(contextMessage: string, placeId?: string): string {
  return placeId ? `${contextMessage}\nGoogle Place ID: ${placeId}` : contextMessage
}
